import Home from "./views/Home";
import About from "./views/About";
import ConnexionExterieurs from "./views/ConnexionExterieurs";
import NouveauCompte from "./views/NouveauCompte";
import OubliMDP from "./views/OubliMDP";
import ResetMDP from "./views/ResetMDP";
import FormProfil from "./views/FormProfil";
import ListeCandidaturesSuaio from "./views/ListeCandidaturesSuaio";
import DetailCandidatureSuaio from "./views/DetailCandidatureSuaio";
import DetailCandidature from "./views/DetailCandidature";
import ListeCandidaturesEnseignant from "./views/ListeCandidaturesEnseignant";
import ListeCandidaturesScolarite from "./views/ListeCandidaturesScolarite";
import DetailCandidatureEnseignant from "./views/DetailCandidatureEnseignant";
import BaseError from "./views/base/BaseError";
import ListeCandidaturesEtudiant from "./views/ListeCandidaturesEtudiant";
import FormCandidature from "./views/FormCandidature";
import BOListeFormations from "./views/BOListeFormations";
import BOEditionFormation from "./views/BOEditionFormation";
import BOAjoutFormation from "./views/BOAjoutFormation";
import BOConsultationArchives from "./views/BOConsultationArchives.vue";
import Parametrage from "./views/Parametrage";
import GestionCampus from "./views/GestionCampus";
import FormCampus from "./views/FormCampus";
import FormCsv from "./views/FormCsv";
import RazCampagne from "./views/RazCampagne";
import GestionStructures from "./views/GestionStructures";
import FormStructure from "./views/FormStructure";
import GestionReferentsScolarite from "./views/GestionReferentsScolarite";
import GestionTypePiece from "./views/GestionTypePiece";
import FormTypePiece from "./views/FormTypePiece";
import RechercheEtudiant from "./views/RechercheEtudiant";
import InscriptionAtelier from "./views/InscriptionAtelier";
import GestionAteliers from "./views/GestionAteliers";
import FormAtelier from "./views/FormAtelier";
import ListeAteliersAnimateur from "./views/ListeAteliersAnimateur";
import EmargementAtelier from "./views/EmargementAtelier";
import InscritsAtelier from "./views/InscritsAtelier";
import Contacts from "./views/Contacts";
import ResetEtatCandidature from "./views/ResetEtatCandidature";

export default {
  definition: [
    // définition des routes :
    /**
     * - path: chemin relatif
     * - name: nom identifiant la route (unique)
     * - icon: icône materiel-design pour le lien dans le menu
     * - title: titre du lien dans le menu
     *
     * - meta: {
     *
     *   - title: titre de la page (balise <title> du <head> HTML)
     *   - menu: doit apparaître dans le menu
     *
     *   - access:
     *     - type: "public" | "anonymous" | "authenticated" | "authorized"
     *        "public"        => Page accès anonyme : toujours présente
     *        "anonymous"     => Page accès anonyme uniquement : présente uniquement si utilisateur non connecté
     *        "authenticated" => Page authentifiée : présente si utilisateur connecté et a les droits pour cela
     *     - roles: si route "authorized", liste des roles user ayant accès à cette route
     *   }
     * }
     */
    {
      path: "/boAjoutFormation",
      name: "boAjoutFormation",
      icon: "login",
      title: "Ajout formation",
      component: BOAjoutFormation,
      meta: {
        title: "Ajout formation",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/nouveauCompte",
      name: "nouveauCompte",
      icon: "public",
      title: "Nouveau compte",
      component: NouveauCompte,
      meta: {
        title: "Nouveau compte",
        menu: true,
        access: {
          type: "masked",
        },
      },
    },
    {
      path: "/connexionExterieurs",
      name: "connexionExterieurs",
      icon: "login",
      title: "Connexion Exterieurs",
      component: ConnexionExterieurs,
      meta: {
        title: "Connexion Exterieurs",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
    {
      path: "/oubliMdp",
      name: "oubliMDP",
      icon: "login",
      title: "Mot de passe oublié",
      component: OubliMDP,
      meta: {
        title: "Mot de passe oublié",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
    {
      path: "/resetPassword/:token",
      name: "resetPassword",
      icon: "login",
      title: "Reset mot de passe",
      component: ResetMDP,
      props: true,
      meta: {
        title: "Reset mot de passe",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
    {
      path: "/mon-profil",
      name: "mon-profil",
      icon: "account_circle",
      title: "Mon Profil",
      component: FormProfil,
      meta: {
        title: "Mon profil",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_PROFIL_ETUDIANT"],
        },
      },
    },
    {
      path: "/inscriptionAtelier",
      name: "inscriptionAtelier",
      icon: "mdi-tools",
      title: "Atelier",
      component: InscriptionAtelier,
      meta: {
        title: "Atelier",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_CAMPAGNE_NORMALE"],
        },
      },
    },
    {
      path: "/mes-candidatures",
      name: "mes-candidatures",
      icon: "library_books",
      title: "Mes candidatures",
      component: ListeCandidaturesEtudiant,
      meta: {
        title: "Mes candidatures",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_ETUDIANT"],
        },
      },
    },
    {
      path: "/form-candidature/:idCandidature?",
      name: "form-candidature",
      icon: "mdi-note-text",
      title: "Candidature",
      component: FormCandidature,
      props: true,
      meta: {
        title: "Candidature",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ETUDIANT"],
        },
      },
    },
    {
      path: "/gestion-ateliers",
      name: "gestion-ateliers",
      icon: "mdi-google-classroom",
      title: "Ateliers",
      component: GestionAteliers,
      meta: {
        title: "Ateliers",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/form-atelier/:idAtelier?",
      name: "form-atelier",
      icon: "mdi-note-text",
      title: "Atelier",
      component: FormAtelier,
      props: true,
      meta: {
        title: "Atelier",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/inscrits-atelier/:idAtelier",
      name: "inscrits-atelier",
      icon: "mdi-google-classroom",
      title: "Inscrits aux ateliers",
      component: InscritsAtelier,
      props: true,
      meta: {
        title: "Inscrits aux ateliers",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/gestion-presences-ateliers",
      name: "gestion-presences-ateliers",
      icon: "mdi-google-classroom",
      title: "Présences aux ateliers",
      component: ListeAteliersAnimateur,
      meta: {
        title: "Présences aux ateliers",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/emargement-atelier/:idAtelier",
      name: "emargement-atelier",
      icon: "mdi-google-classroom",
      title: "Émargement à un atelier",
      component: EmargementAtelier,
      props: true,
      meta: {
        title: "Émargement à un atelier",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/listing-suaio/:idFormation?/:idCampus?",
      name: "listing-suaio",
      icon: "mdi-account-multiple",
      title: "Candidatures",
      props: true,
      component: ListeCandidaturesSuaio,
      meta: {
        title: "Candidatures",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/listing-enseignant/:idFormation?",
      name: "listing-enseignant",
      icon: "mdi-account-multiple",
      title: "Candidatures",
      props: true,
      component: ListeCandidaturesEnseignant,
      meta: {
        title: "Candidatures",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_ENSEIGNANT", "ROLE_STRUCTURE"],
        },
      },
    },
    {
      path: "/listing-scolarite",
      name: "listing-scolarite",
      icon: "mdi-account-multiple",
      title: "Candidatures",
      component: ListeCandidaturesScolarite,
      meta: {
        title: "Candidatures",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_SCOLARITE"],
        },
      },
    },
    {
      path: "/recherche-etudiant",
      name: "recherche-etudiant",
      icon: "account_circle",
      title: "Situation étudiant",
      component: RechercheEtudiant,
      meta: {
        title: "Situation étudiant",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_SUAIO", "ROLE_SCOLARITE"],
        },
      },
    },
    {
      path: "/detail-candidature/:idCandidature",
      name: "detail-candidature",
      icon: "account_circle",
      title: "detail-candidature",
      component: DetailCandidature,
      props: true,
      meta: {
        title: "detail-candidature",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ENSEIGNANT", "ROLE_SUAIO", "ROLE_SCOLARITE"],
        },
      },
    },
    {
      path: "/candidature-suaio/:idCandidature/:idCampus",
      name: "candidature-suaio",
      icon: "account_circle",
      title: "Candidature",
      component: DetailCandidatureSuaio,
      props: true,
      meta: {
        title: "Candidature",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/candidature-enseignant/:idCandidature",
      name: "candidature-enseignant",
      icon: "account_circle",
      title: "Candidature",
      component: DetailCandidatureEnseignant,
      props: true,
      meta: {
        title: "Candidature",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ENSEIGNANT", "ROLE_STRUCTURE"],
        },
      },
    },
    {
      path: "/",
      name: "home",
      icon: "dashboard",
      title: "Accueil",
      component: Home,
      meta: {
        title: "Accueil",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
    {
      path: "/parametrage",
      name: "parametrage",
      icon: "mdi-cogs",
      title: "Paramétrage",
      component: Parametrage,
      meta: {
        title: "Paramétrage",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/download-csv",
      name: "formCsv",
      icon: "mdi-database-export",
      title: "Statistiques",
      component: FormCsv,
      meta: {
        title: "Statistiques",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN", "ROLE_SUAIO", "ROLE_STRUCTURE"],
        },
      },
    },
    {
      path: "/razCampagne",
      name: "razCampagne",
      icon: "mdi-eraser",
      title: "RAZ Campagne",
      component: RazCampagne,
      meta: {
        title: "RAZ Campagne",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/boConsultationArchives",
      name: "boConsultationArchives",
      icon: "mdi-archive-search",
      title: "Consultation des archives",
      component: BOConsultationArchives,
      meta: {
        title: "Consultation des archives",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/boListFormations",
      name: "boListFormations",
      icon: "mdi-bookshelf",
      title: "Gestion des formations",
      component: BOListeFormations,
      meta: {
        title: "Gestion des formations",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN", "ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/boEditionFormation/:idFormation",
      name: "boEditionFormation",
      icon: "mdi-note-text",
      title: "Edition formation",
      props: true,
      component: BOEditionFormation,
      meta: {
        title: "Edition formation",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN", "ROLE_SUAIO"],
        },
      },
    },
    {
      path: "/gestion-campus",
      name: "gestion-campus",
      icon: "mdi-bookshelf",
      title: "Gestion des campus",
      component: GestionCampus,
      meta: {
        title: "Gestion des campus",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/form-campus/:idCampus?",
      name: "form-campus",
      icon: "mdi-note-text",
      title: "Campus",
      component: FormCampus,
      props: true,
      meta: {
        title: "Campus",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/gestion-structures",
      name: "gestion-structures",
      icon: "mdi-bookshelf",
      title: "Gestion des structures",
      component: GestionStructures,
      meta: {
        title: "Gestion des structures",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/form-structure/:idStructure?",
      name: "form-structure",
      icon: "mdi-note-text",
      title: "Structure",
      component: FormStructure,
      props: true,
      meta: {
        title: "Structure",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/gestion-typePiece",
      name: "gestion-typePiece",
      icon: "mdi-bookshelf",
      title: "Gestion des types de pièce",
      component: GestionTypePiece,
      meta: {
        title: "Gestion des types de pièce",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/form-typePiece/:idTypePiece?",
      name: "form-typePiece",
      icon: "mdi-note-text",
      title: "Type piece",
      component: FormTypePiece,
      props: true,
      meta: {
        title: "Type piece",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/gestion-referents-scolarite",
      name: "gestion-referents-scolarite",
      icon: "mdi-bookshelf",
      title: "Gestion des référents scolarité",
      component: GestionReferentsScolarite,
      meta: {
        title: "Gestion des référents scolarité",
        menu: false,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/reset-candidature-etudiant",
      name: "reset-candidature-etudiant",
      icon: "lock_reset",
      title: "RESET état candidature",
      component: ResetEtatCandidature,
      meta: {
        title: "RESET état candidature",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_ADMIN"],
        },
      },
    },
    {
      path: "/about",
      name: "about",
      icon: "question_answer",
      title: "A propos",
      component: About,
      meta: {
        title: "A propos",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_PROFIL_ETUDIANT"],
        },
      },
    },
    {
      path: "/contacts",
      name: "contacts",
      icon: "question_answer",
      title: "Contacts",
      component: Contacts,
      meta: {
        title: "Contacts",
        menu: true,
        access: {
          type: "authenticated",
          roles: ["ROLE_ENSEIGNANT"],
        },
      },
    },
    {
      path: "/erreur",
      name: "erreur",
      component: BaseError,
      props: {
        message: "Une erreur est survenue",
      },
      meta: {
        title: "Page d'erreur",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
    {
      path: "*",
      name: "notfound",
      component: BaseError,
      props: {
        message: "La page spécifiée est introuvable",
      },
      meta: {
        title: "Page non trouvée",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      component: BaseError,
      props: {
        message: "Vous n'êtes pas autorisé à accéder à cette page",
      },
      meta: {
        title: "Ressource non autorisée",
        menu: false,
        access: {
          type: "public",
        },
      },
    },
  ],
};
